/**
 * PeriodField — триггер выбора периода (кнопка тулбара `button` или строка
 * `row` для фильтр-шита) + общий PeriodPicker. Держит своё open-состояние.
 */

import {useState} from 'react';
import {ChevronDown, ChevronRight} from 'lucide-react';

import {PeriodPicker} from './PeriodPicker';
import {type Range, rangeLabel} from './periods';

type PeriodFieldProps = {
  value: Range;
  onChange: (r: Range) => void;
  mobile?: boolean;
  variant?: 'button' | 'row';
};

export const PeriodField = ({
  value,
  onChange,
  mobile = false,
  variant = 'button',
}: PeriodFieldProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {variant === 'row' ? (
        <button
          onClick={() => setOpen(true)}
          className="flex w-full items-center justify-between border-t border-skr-hairline py-3.5 text-left outline-none"
        >
          <span className="text-[14.5px] text-foreground">Период</span>
          <span className="flex items-center gap-1.5 text-[14px] text-muted-foreground">
            {rangeLabel(value)}
            <ChevronRight className="size-[17px] text-skr-chevron" strokeWidth={2} />
          </span>
        </button>
      ) : (
        <button
          onClick={() => setOpen(true)}
          className="flex h-10 items-center gap-2 rounded-[10px] border border-input bg-card px-[13px] text-[13.5px] text-skr-ink outline-none hover:bg-secondary/60"
        >
          {rangeLabel(value)}
          <ChevronDown className="size-3.5 text-muted-foreground" />
        </button>
      )}

      <PeriodPicker
        open={open}
        onOpenChange={setOpen}
        mobile={mobile}
        value={value}
        onApply={onChange}
      />
    </>
  );
};
